export default __webpack_public_path__ + "static/media/workthree.2fd8831a.jpg";